<div class="modal-header">
   <h4 class="modal-title">Change Plan</h4>
   <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>
<div class="modal-body">
   @if (isLoading()) {
   <div class="d-flex justify-content-center my-3">
      <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
         <span class="visually-hidden">Loading...</span>
      </div>
   </div>
   } @else if (errorMessage()) {
   <div class="alert alert-danger my-3" role="alert">
      <strong>Unable to load plan options.</strong>
      <div class="small">{{ errorMessage() }}</div>
   </div>
   } @else {
      @if (actionableSubscription(); as sub) {
      <fieldset>
         <legend class="mb-3">Current Plan</legend>
         <app-account-card [actionableSubscription]="sub" />
      </fieldset>
      <!--<h6 class="text-muted mb-2">Current Plan</h6>
      <app-account-card [actionableSubscription]="sub" />-->
      }

      <fieldset class="mt-4">
         <legend class="mb-0">Available Plans</legend>
         @if (conversionOptions().length) {
         <div class="row g-3">
            @for (option of conversionOptions(); track option.id) {
            <div class="col-12 col-md-6">
               <div class="card h-100 plan-card"
                    role="button"
                    tabindex="0"
                    [class.border-primary]="selectedOption()?.id === option.id"
                    [class.selected]="selectedOption()?.id === option.id"
                    [class.border-success]="option.isPlanned && selectedOption()?.id !== option.id"
                    (click)="selectPlan(option)"
                    (keydown.enter)="selectPlan(option)"
                    (keydown.space)="selectPlan(option)">
                  <div class="card-body">
                     <div class="d-flex justify-content-between align-items-start">
                        <h6 class="card-title">{{ option.productSummary }}</h6>
                        @if (option.isPlanned) {
                        <span class="badge bg-success">Current Renewal Plan</span>
                        }
                     </div>
                     <p class="card-text mb-1"><span class="fw-bold">Source:</span> {{ option.productSourceId }}</p>
                     <p class="card-text mb-1"><span class="fw-bold">Billing:</span> {{ BillingFrequency.toDomainModel(option.billingFrequencyCode)?.description }}</p>
                     <p class="card-text mb-0"><span class="fw-bold">Amount:</span> {{ option.subscriptionAuthorizationAmount | currency }}</p>
                  </div>
               </div>
            </div>
            }
         </div>
         } @else {
         <p class="text-muted mb-0"><em>No plan options available.</em></p>
         }
      </fieldset>
      <!--<h6 class="text-muted mt-3 mb-2">Available Plans</h6>-->
   }
</div>
<div class="modal-footer">
   <div class="d-flex flex-column gap-2 me-auto">
      @if (submitErrorMessage()) {
      <div class="alert alert-danger mb-0 py-1 px-2" role="alert">
         <span class="small">{{ submitErrorMessage() }}</span>
      </div>
      }
      @if (selectedOption(); as option) {
      <div class="alert alert-warning d-flex align-items-center gap-2 mb-0 py-1 px-2">
         <span class="small">Change plan to <strong>{{ option.productDisplayName }}</strong> ({{ option.subscriptionAuthorizationAmount | currency }})@if (selectedOptionEffective(); as effective) { effective <strong>{{ effective | date:'MM/dd/yy' }}</strong>}?</span>
         <button type="button" class="btn btn-sm btn-success" [disabled]="isSubmitting()" (click)="confirmChangePlan()">Confirm</button>
      </div>
      }
   </div>
   <button type="button" class="btn btn-secondary" [disabled]="isSubmitting()" (click)="cancel()">Cancel</button>
</div>
